import type {KeyboardEvent,ReactNode,RefObject} from 'react'

/** Leave native typing/playback intact, but do not bubble Help keys to business shortcuts. */
function isolate(event:KeyboardEvent<HTMLDivElement>){event.stopPropagation()}

export function HelpKeyboardBoundary({children,containerRef}:{children:ReactNode;containerRef:RefObject<HTMLDivElement|null>}){
  return <div ref={containerRef} onKeyDown={isolate} onKeyUp={isolate} onKeyPress={isolate}>{children}</div>
}
